import React from "react";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik } from "formik";
import { Grid, Typography, Card } from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import api from "../../../components/services/api";

export default function EditDepots() {
  const [depots_name, setDepots_name] = useState();
  const [depots_no, setDepots_no] = useState();
  const [depots_status, setDepots_status] = useState(1);
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [tel, setTel] = useState("");
  const [mac5code, setMAC5Code] = useState("");
  const [contact, setContact] = useState("");
  let { id } = useParams();
  //config api

  //fetch Data

  const data_params = { id: id };
  const getData = async () => {
    try {
      const data = await api
        .post("api/depots/detail", data_params)
        .then((response) => {
          if (response.data.length !== 0) {
            [].concat(response.data).map((res) => {
              // console.log(res.FreightTermsNo);
              setDepots_name(res.DepotsName);
              setDepots_no(res.DepotsNo);
              setMAC5Code(res.DepotsMAC5Code)
              setAddress(res.DepotsAddress)
              setContact(res.DepotsContactName)
              setEmail(res.DepotsEmail)
              setTel(res.DepotsTel)
              // console.log(`ft`, res.TransshipmentNo);
              // res.Status.data.map((res) => {
              //   setDepots_status(res.Status === true ? 1 : 0);
              // });
              setDepots_status(res.Status === true ? 1 : 0);
            });
          } else {
            const MySwal = withReactContent(Swal);

            MySwal.fire({
              icon: "success",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire(
                "ผิดพลาด!",
                "ไม่พบรหัสโรงเก็บพัสดุดังกล่าว !",
                "error"
              ).then((result) => {
                if (result.isConfirmed) {
                  history.push("/Setting/Depots");
                }
              });
            });
            // console.log("Nodata" + response);
          }

          //   console.log(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  };
  //api call
  useEffect(() => {
    // GET request using axios inside useEffect React hook
    getData();

    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, []);

  const history = useHistory();
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          โรงเก็บพัสดุ
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Depots
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / Depots
            </Typography>
          </Grid>
        </Grid>
        <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
          แก้ไขโรงเก็บพัสดุ
        </h6>
        <Formik
          initialValues={{ transshipment_name: "", transshipment_no: "" }}
          validate={(values) => {
            const errors = {};
            if (!depots_name || depots_name === "") {
              errors.f_t_name = "Required";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              const data = {
                id: id,
                no: depots_no,
                name: depots_name,
                status: depots_status,
                DepotsMAC5Code: mac5code,
                DepotsAddress: address,
                DepotsContactName: contact,
                DepotsEmail: email,
                DepotsTel: tel
              };

              api
                .post(
                  "api/depots/update",
                  data
                )
                .then((respose) => {
                  const MySwal = withReactContent(Swal);

                  MySwal.fire({
                    icon: "success",
                    didOpen: () => {
                      MySwal.clickConfirm();
                    },
                  }).then(() => {
                    return MySwal.fire(
                      "สำเร็จ!",
                      "แก้ไขข้อมูลโรงเก็บพัสดุสำเร็จ !",
                      "success"
                    ).then((result) => {
                      if (result.isConfirmed) {
                        history.push("/Setting/Depots");
                      }
                    });
                  });
                  // console.log(respose);
                })
                .catch((err) => {
                  console.log(err);
                });

              // alert(JSON.stringify(f_t_no + f_t_name + f_t_status, null, 2));
              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2} sx={{ marginBottom: '20px' }}>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    name="depots_name"
                    label="Depots NAME"
                    variant="outlined"
                    placeholder="Depots NAME"
                    onChange={(e) => setDepots_name(e.target.value)}
                    onBlur={handleBlur}
                    style={{ width: "100%" }}
                    InputLabelProps={{ shrink: true }}
                    value={depots_name}
                  />
                  {errors.depots_name &&
                    touched.depots_name &&
                    errors.depots_name}
                </Grid>
                <Grid item xs={12} sm={6} md={6}></Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="Depots NO."
                    InputLabelProps={{ shrink: true }}
                    placeholder="Enter Depots  NO."
                    name="depots_no"
                    style={{
                      width: "100%",

                    }}
                    onChange={(e) => setDepots_no(e.target.value)}
                    onBlur={handleBlur}
                    value={depots_no}
                  />
                  {errors.depots_no && touched.depots_no && errors.depots_no}
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    name="MAC5"
                    label="MAC-5 Code "
                    variant="outlined"
                    placeholder="Enter MAC-5 Code "
                    style={{
                      width: "100%",

                    }}
                    onChange={(e) => {
                      setMAC5Code(e.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={mac5code}

                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}></Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    name="Address"
                    label="Address"
                    variant="outlined"
                    placeholder="Enter Address"
                    style={{
                      width: "100%",

                    }}
                    onChange={(e) => {
                      setAddress(e.target.value)
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={address}

                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}></Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    name="Contact"
                    label="Contact Name"
                    variant="outlined"
                    placeholder="Enter Contact Name"
                    style={{
                      width: "100%",

                    }}
                    onChange={(e) => {
                      setContact(e.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={contact}

                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    name="Email"
                    label="Email"
                    variant="outlined"
                    placeholder="Enter Email"
                    style={{
                      width: "100%",

                    }}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={email}

                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}></Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    name="Telephone"
                    label="Telephone"
                    variant="outlined"
                    placeholder="Enter Telephone"
                    style={{
                      width: "100%",

                    }}
                    onChange={(e) => {
                      setTel(e.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={tel}

                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>

                  <FormControl fullWidth>
                    <InputLabel id="select_status-label">Status</InputLabel>
                    <Select
                      name="select_status"
                      id="select_status"
                      value={depots_status}
                      label="Status"
                      style={{
                        width: "100%",

                      }}
                      onChange={(e) => setDepots_status(e.target.value)}
                    >
                      <MenuItem value={1}>Active</MenuItem>
                      <MenuItem value={0}>InActive</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

              </Grid>
              <Button
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                onClick={history.goBack}
              >
                back
              </Button>
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                disabled={isSubmitting}
              >
                {isSubmitting && <CircularProgress size={22} />}
                {!isSubmitting && "SAVE"}
              </Button>
            </form>
          )}
        </Formik>
      </Card>
    </div>
  );
}
